/* eslint-disable */
const analyticsUtil = {
    identify: (id, data) => {
        try {
            analytics.identify(id, data)
        } catch (err) {
            if (window.Sentry) {
                window.Sentry.captureException(err);
            } else {
                console.log('no sentry found');
            }
        }
    },
    group: (id, data) => {
        try {
            analytics.group(id, data);
        } catch (err) {
            if (window.Sentry) {
                window.Sentry.captureException(err);
            } else {
                console.log('no sentry found');
            }
        }
    },
    page: (pageName) => {
        // console.log(pageName);
        if (pageName == '/') {
            pageName = 'home';
        }
        try {
            analytics.page(pageName);
        } catch (err) {
            if (window.Sentry) {
                window.Sentry.captureException(err);
            } else {
                console.log('no sentry found');
            }
        }
    },
    track: (eventName, data) => {
        // console.log('in track');
        // console.log(eventName);
        // console.log(data);
        try {
            analytics.track(eventName, data);
        } catch (err) {
            if (window.Sentry) {
                window.Sentry.captureException(err);
            } else {
                console.log('no sentry found');
            }
        }
    },
    reset: () => {
        try {
            analytics.reset();
        } catch (err) {
            if (window.Sentry) {
                window.Sentry.captureException(err);
            } else {
                console.log('no sentry found');
            }
        }
    }
};
export default analyticsUtil;


// WEBPACK FOOTER //
// /src/utils/segmentUtils.js